import React from 'react'

export const SappTitleSolution = ({ title }: { title: string }) => {
  return <div className="text-base font-semibold text-bw-1 ">{title}</div>
}
